// extracted by mini-css-extract-plugin
export default {"secondaryNavigation":"SecondaryNavigation_secondaryNavigation__K1YkY"};